var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticStyle:{"cursor":"pointer","width":"6vw","height":"1.5vw","border-radius":"8px","margin-top":"0px","outline":"none","background":"#4e5fff"},on:{"click":_vm.handleButtonClick}},[_vm._v("+ Add")])])
}
var staticRenderFns = []

export { render, staticRenderFns }